var internet = {};
module['exports'] = internet;
internet.free_email = require("./free_email");
internet.domain_suffix = require("./domain_suffix");
internet.avatar_uri = require("./avatar_uri");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/internet/index.js
 ** module id = 462
 ** module chunks = 0
 **/